import { FileSpreadsheet } from 'lucide-react'

import { Card } from '@ankor-io/ui-components'

import XeroLogoSrc from '@/assets/Xero.svg'

export const PipelineSelectorView = ({ organizationId }: { organizationId: string }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <Card
        icon={
          <img
            src={XeroLogoSrc}
            alt="Xero"
            className="size-5"
          />
        }
        layout="vertical"
        title="Xero Sync"
        description="View sync jobs, runs, and pipeline stages for the connected Xero integration."
        link={`/organizations/${organizationId}/integrations?screen=syncJobs&integrationKey=xero_expenses`}
      />
      <Card
        icon={<FileSpreadsheet className="size-10 text-primary-600 dark:text-primary-400" />}
        layout="vertical"
        title="Report Generation"
        description="Inspect generated report jobs, pipeline runs, stages, and step logs."
        link={`/organizations/${organizationId}/pipelines?screen=reportGenJobs`}
      />
    </div>
  )
}
